// src/components/issues/tableau/MenuRegroupement.tsx — SCE Issues
// Le choix du regroupement : aucun, N° de série, PN, métier, statut.

import { Popover } from '@/components/ui/Popover'
import { LIBELLE_REGROUPEMENT, REGROUPEMENTS, type Regroupement } from '@/utils/tableauProblemes'

const premiereMajuscule = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1)

export interface MenuRegroupementProps {
  ancre: HTMLElement
  valeur: Regroupement | null
  onChoisir: (mode: Regroupement | null) => void
  onClose: () => void
}

export function MenuRegroupement({ ancre, valeur, onChoisir, onClose }: MenuRegroupementProps): JSX.Element {
  const options: { mode: Regroupement | null; libelle: string }[] = [
    { mode: null, libelle: 'Aucun regroupement' },
    ...REGROUPEMENTS.map((mode) => ({ mode, libelle: premiereMajuscule(LIBELLE_REGROUPEMENT[mode]) })),
  ]
  return (
    <Popover ancre={ancre} onClose={onClose} titre="Regrouper par" largeur={240}>
      <div className="popover-entete">
        <span>Regrouper par</span>
      </div>
      <div className="popover-liste">
        {options.map((o) => (
          <label key={o.mode ?? 'aucun'} className="tableau-option">
            <input
              type="radio"
              name="regroupement"
              checked={valeur === o.mode}
              onChange={() => {
                onChoisir(o.mode)
                onClose()
              }}
            />
            <span className="tableau-option-libelle">{o.libelle}</span>
          </label>
        ))}
      </div>
    </Popover>
  )
}
